module.exports = __webpack_public_path__ + "img/lepricon.b68c467f.png";